import React from 'react';
import { DOCUMENTS_PANEL, DOCUMENT_ICON_PATH } from './constants';

/**
 * Button that shows document counts (Cheat Sheets & Worksheets) and toggles the dropdown.
 * The panel opens/closes ONLY when this button is clicked (or document.getElementById('documents-button').click()).
 *
 * Visibility (visible true/false) is controlled from the iframe via postMessage:
 *   Show: window.parent.postMessage({ type: 'SHOW_DOCUMENTS_BUTTON' }, '*');
 *   Hide: window.parent.postMessage({ type: 'HIDE_DOCUMENTS_BUTTON' }, '*');
 * See IFRAME_COMMUNICATION.md for full guide.
 */
export function DocumentsButton({
  cheatSheetCount,
  workSheetCount,
  onClick,
  showPanel = false,
  visible = true,
}) {
  const hasDocuments = cheatSheetCount > 0 || workSheetCount > 0;
  if (!hasDocuments) return null;

  const parts = [];
  if (cheatSheetCount > 0) {
    parts.push(`Cheat Sheet${cheatSheetCount > 1 ? 's' : ''} (${cheatSheetCount})`);
  }
  if (workSheetCount > 0) {
    parts.push(`Worksheet${workSheetCount > 1 ? 's' : ''} (${workSheetCount})`);
  }

  // visible is set by parent from postMessage: SHOW_DOCUMENTS_BUTTON (true) / HIDE_DOCUMENTS_BUTTON (false)
  const className = visible ? 'button' : 'button documents-button-hidden';

  return (
    <button
      id="documents-button"
      className={className}
      onClick={onClick}
      type="button"
      style={{
        padding: '0.75rem 1.5rem',
        fontSize: '0.9rem',
        cursor: 'pointer',
        zIndex: 10,
        backgroundColor: showPanel ? DOCUMENTS_PANEL.primaryColor : 'white',
        color: showPanel ? 'white' : DOCUMENTS_PANEL.primaryColor,
        border: `2px solid ${DOCUMENTS_PANEL.primaryColor}`,
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        transition: 'all 0.2s',
      }}
    >
      <DocumentIcon />
      <span>{parts.join(' & ')}</span>
      <svg
        style={{
          width: '1rem',
          height: '1rem',
          transform: showPanel ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s',
        }}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
  );
}

function DocumentIcon() {
  return (
    <svg
      style={{ width: '1.25rem', height: '1.25rem' }}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d={DOCUMENT_ICON_PATH}
      />
    </svg>
  );
}
